var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepresentativeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27.429,
    viewBox: "0 0 24 27.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-tie-solid",
    d: "M5.143,6.857A6.857,6.857,0,1,0,12,0,6.857,6.857,0,0,0,5.143,6.857Zm5.063,10.725,1,1.661L9.418,25.88l-1.929-7.87a.793.793,0,0,0-.959-.605A8.639,8.639,0,0,0,0,25.784a1.645,1.645,0,0,0,1.645,1.645H22.355A1.645,1.645,0,0,0,24,25.784a8.639,8.639,0,0,0-6.53-8.379.8.8,0,0,0-.959.605l-1.929,7.87L12.8,19.243l1-1.661a.856.856,0,0,0-.734-1.3H10.945a.857.857,0,0,0-.734,1.3Z",
    fill: "#c9c9c9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepresentativeIcon);
export default __webpack_public_path__ + "static/media/representative-icon.91dac14a10354ba1394b1c79b16ef295.svg";
export { ForwardRef as ReactComponent };